var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 625,
    viewBox: "0 0 433 625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413 129V109H20V129H0V605H20V625H413V605H433V129H413Z",
    fill: "#FFDC6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.09 49.34V32.62H261.1V24.63H253.11V16.71H245.11V16.53H244.93V8.53001H225.46V0.540009H193.57V8.53001H173.18V16.53V16.71H165.18V24.63H157.19V32.62H149.2V49.34H141.2V80.78H149.2V96.46H157.19V112.44H165.18V120.44H173.18V128.43H189.16V136.42H229.13V128.43H245.11V120.44H253.11V112.44H261.1V96.46H269.09V80.78H277.09V49.34H269.09Z",
    fill: "#FDAE35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.13 128.41H181.17V120.41H173.18H173V112.42H165.18V104.43H157.19V96.44H149.2V80.78H141.2V96.77H149.2V112.42H157.19V120.41H165.01H165.18V128.41H173.18V136.42H193.37V128.43H181.17L181.13 128.41Z",
    fill: "#D38B2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.46 136.44H193.57V144.43H225.46V136.44Z",
    fill: "#D38B2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.09 80.78V96.44H261.1V104.43H253.11V112.42H245.11V120.41H237.12V128.41H237.16L237.12 128.43H225.25V136.42H245.11V128.41H253.11V120.41H261.1V112.42H269.09V96.77H277.09V80.78H269.09Z",
    fill: "#D38B2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.11 24.35H237.12V32.34H245.11V24.35Z",
    fill: "#FFEBD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.12 20.52H233.12V24.52H237.12V20.52Z",
    fill: "#FFDAA9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.11 32.35H245.11V36.35H249.11V32.35Z",
    fill: "#FFDAA9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.1 78.99H221.13V86.98H253.1V78.99Z",
    fill: "#A32732"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.151 78.99H165.181V86.98H197.151V78.99Z",
    fill: "#A32732"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.18 57.78H197.16V78.99H205.15V57.78H213.14V78.14H221.13V57.78H229.13H237.12H253.11V78.14H261.1V49.79H157.19V78.14H165.18V57.78Z",
    fill: "#A32732"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.151 57.78H165.181V78.99H197.151V57.78Z",
    fill: "#ECF0F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.101 57.78H221.131V78.99H253.101V57.78Z",
    fill: "#ECF0F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M241.54 70.25H235.29V81.18H241.54V70.25Z",
    fill: "#A32732"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.83 70.25H180.58V81.18H186.83V70.25Z",
    fill: "#A32732"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionLeft);
export default __webpack_public_path__ + "static/media/question-left.75a9edf74c076fb903b5f2fe437dc64c.svg";
export { ForwardRef as ReactComponent };